import { animate, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { commonModules } from '../../../common_modules';

/**
 * DO NOT USE onPush Changedetection. Message needs to be updated and inputsignal can't be used here for now
 */
@Component({
  selector:        'app-snack-bar',
  imports:         [
    commonModules
  ],
  templateUrl:     './snackbar.component.html',
  styleUrl:        './snackbar.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  animations:      [
    trigger('fade', [
      transition('void => *', [
        style({
          transform: 'scale(0.8)',
          opacity: '0%'
        }),
        animate(
          '150ms cubic-bezier(0, 0, 0.2, 1)',
          style({
            transform: 'scale(1)',
            opacity: '100%'
          })
        )
      ]),
      transition(
        '* => void',
        animate(
          '150ms cubic-bezier(0.4, 0.0, 1, 1)',
          style({
            opacity: 0,
          }),
        ),
      ),
    ])
  ]
})
export class SnackbarComponent {

  @Input()
  public message: string = null;
}
